import { render, staticRenderFns } from "./Navbar_Settings.vue?vue&type=template&id=bf7dfbaa&"
import script from "./Navbar_Settings.vue?vue&type=script&lang=js&"
export * from "./Navbar_Settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports